import React, { FC } from "react";
import { styled } from "@material-ui/styles";
import { useHistory } from "react-router-dom";

type BackButtonProps = {
  label?: string;
  to?: string;
};

const StyledButton = styled("button")(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
  marginBottom: 16,
  padding: 0,
  border: "none",
  background: "none",
  cursor: "pointer",
  fontSize: 13,
  fontWeight: 500,
  color: theme.palette.brand.gray500,
  "&:hover": {
    color: theme.palette.brand.gray700,
  },
}));

const BackButton: FC<BackButtonProps> = ({ label = "Back", to }) => {
  const history = useHistory();

  const handleClick = () => {
    if (to) {
      history.push(to);
    } else {
      history.goBack();
    }
  };

  return (
    <StyledButton type="button" onClick={handleClick}>
      ← {label}
    </StyledButton>
  );
};

export default BackButton;
